import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2704,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
						paddingBottom: 97,
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 201,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/7mtbewqi_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Guy Hawkins"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
										borderRadius: 3,
										paddingTop: 1,
										paddingBottom: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentee"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 2,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/y4t5hvbg_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"yourguy123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 32,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hl8aijhf_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Dashboard"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 4,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lupu7q5z_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Requests"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/k42yp9t2_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"My Goals"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 30,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/a8qc0dw8_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Chats"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 50,
									marginBottom: 30,
									marginLeft: 20,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/oi8cpduh_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Curriculum"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/y1ioef2m_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Lessons"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0qtxcszu_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Resources"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/s3it4yoi_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Mentors"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/egx5ejpc_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Progress"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0wemtrge_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Community"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/l1svfwxn_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Bookmarks"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 40,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0heh9cdg_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Downloads"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginBottom: 40,
									marginLeft: 32,
									marginRight: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/pa0bkewe_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Notifications"}
								</span>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									paddingRight: 3,
									marginLeft: 32,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/j6sul4l9_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 16,
									}} >
									{"Settings"}
								</span>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: 227,
								width: 1213,
								display: "flex",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 20,
								paddingBottom: 20,
								paddingLeft: 40,
								paddingRight: 40,
								boxShadow: "0px -2px 4px #00000000",
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									flex: 1,
								}} >
								{"© 2025 Global Impact Innovators. All Rights Reserved."}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 27,
								}} >
								{"Privacy"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
									marginRight: 26,
								}} >
								{"Terms of Service"}
							</span>
							<span 
								style={{
									color: "#979797",
									fontSize: 14,
								}} >
								{"Help & FAQ"}
							</span>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ikfmrp5u_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input1}
								onChange={(event)=>onChangeInput1(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/dqzd3xch_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/2l9wbu4p_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/06ars4iy_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginLeft: 267,
						}} >
						{"Curriculum"}
					</span>
					<div 
						style={{
							alignSelf: "stretch",
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-end",
							marginBottom: 40,
						}}>
						<span 
							style={{
								color: "#6C6C6C",
								fontSize: 18,
								marginRight: 36,
							}} >
							{"Explore all curriculum"}
						</span>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							borderRadius: 12,
							paddingTop: 1,
							paddingBottom: 1,
							paddingLeft: 24,
							paddingRight: 24,
							marginLeft: 263,
							boxShadow: "0px 1px 3px #00000003",
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
								marginRight: 20,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Curriculum"}
							</span>
							<div 
								style={{
									width: 290,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FAFAFA",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									padding: 12,
									marginBottom: 24,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/vmic1e1g_expires_30_days.png"} 
									style={{
										width: 21,
										height: 21,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Search curriculum..."}
									value={input2}
									onChange={(event)=>onChangeInput2(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 98,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 20,
								}}>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
										marginRight: 69,
									}} >
									{"List of Modules"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#E7F1F8",
										borderRadius: 28,
										border: `1px solid #9DC6E4`,
										paddingTop: 4,
										paddingBottom: 4,
										paddingLeft: 12,
										paddingRight: 12,
										gap: 5,
									}}>
									<span 
										style={{
											color: "#1074BC",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"In Progress"}
									</span>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3e0cv7jt_expires_30_days.png"} 
										style={{
											borderRadius: 28,
											width: 8,
											height: 4,
											objectFit: "fill",
										}}
									/>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									marginBottom: 21,
									gap: 12,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										gap: 12,
									}}>
									<button 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
											borderRadius: 4,
											border: "none",
											paddingTop: 6,
											paddingBottom: 6,
											paddingLeft: 12,
											paddingRight: 12,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Entrepreneurship"}
										</span>
									</button>
									<button 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 4,
											border: `1px solid #E6E6E6`,
											paddingTop: 6,
											paddingBottom: 6,
											paddingLeft: 12,
											paddingRight: 12,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
											}} >
											{"Business"}
										</span>
									</button>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										gap: 12,
									}}>
									<button 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 4,
											border: `1px solid #E6E6E6`,
											paddingTop: 6,
											paddingBottom: 6,
											paddingLeft: 12,
											paddingRight: 12,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
											}} >
											{"Marketing"}
										</span>
									</button>
									<button 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 4,
											border: `1px solid #E6E6E6`,
											paddingTop: 6,
											paddingBottom: 6,
											paddingLeft: 12,
											paddingRight: 12,
											textAlign: "left",
										}}
										onClick={()=>alert("Pressed!")}>
										<span 
											style={{
												color: "#979797",
												fontSize: 12,
											}} >
											{"Leadership"}
										</span>
									</button>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 19,
									paddingBottom: 19,
									marginBottom: 20,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 17,
										marginLeft: 9,
										marginRight: 9,
										gap: 7,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/u37o1ai6_expires_30_days.png"} 
										style={{
											width: 54,
											height: 54,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 12,
												fontWeight: "bold",
												marginBottom: 6,
											}} >
											{"Entrepreneurship Fundamentals"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												marginBottom: 5,
												gap: 8,
											}}>
											<span 
												style={{
													color: "#F36421",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Completed 3/5 lessons"}
											</span>
											<div 
												style={{
													flexShrink: 0,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													background: "#EEBD10",
													borderRadius: 2,
													paddingTop: 3,
													paddingBottom: 3,
													paddingLeft: 6,
													paddingRight: 6,
												}}>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 10,
														fontWeight: "bold",
													}} >
													{"In Progress"}
												</span>
											</div>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "flex-start",
												gap: 13,
											}}>
											<span 
												style={{
													color: "#979797",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Last studied: 2 days ago"}
											</span>
											<span 
												style={{
													color: "#74AED8",
													fontSize: 10,
													fontWeight: "bold",
													marginTop: 2,
													marginBottom: 2,
												}} >
												{"50% Completed"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "#FEF0E9",
										borderRadius: 8,
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 13,
										paddingRight: 13,
										marginBottom: 12,
										marginLeft: 12,
										marginRight: 12,
										gap: 5,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/sku70z56_expires_30_days.png"} 
										style={{
											width: 24,
											height: 24,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 4,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Next Lesson"}
										</span>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 10,
												fontWeight: "bold",
											}} >
											{"Business Planning Strategies"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 12,
										marginRight: 12,
										gap: 10,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 9,
											paddingLeft: 38,
											paddingRight: 38,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Continue"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											background: "linear-gradient(180deg, #74AED8, #1074BC)",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 9,
											paddingLeft: 28,
											paddingRight: 28,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"View Details"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 19,
									paddingBottom: 19,
									marginBottom: 20,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 17,
										marginLeft: 9,
										marginRight: 9,
										gap: 7,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/0sxmwzet_expires_30_days.png"} 
										style={{
											width: 54,
											height: 54,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 12,
												fontWeight: "bold",
												marginBottom: 6,
											}} >
											{"Business Model & Strategy"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												marginBottom: 5,
												gap: 8,
											}}>
											<span 
												style={{
													color: "#F36421",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Completed 2/5 lessons"}
											</span>
											<div 
												style={{
													flexShrink: 0,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													background: "#EEBD10",
													borderRadius: 2,
													paddingTop: 3,
													paddingBottom: 3,
													paddingLeft: 6,
													paddingRight: 6,
												}}>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 10,
														fontWeight: "bold",
													}} >
													{"In Progress"}
												</span>
											</div>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "flex-start",
												gap: 13,
											}}>
											<span 
												style={{
													color: "#979797",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Last studied: 2 days ago"}
											</span>
											<span 
												style={{
													color: "#74AED8",
													fontSize: 10,
													fontWeight: "bold",
													marginTop: 2,
													marginBottom: 2,
												}} >
												{"50% Completed"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "#FEF0E9",
										borderRadius: 8,
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 13,
										paddingRight: 13,
										marginBottom: 12,
										marginLeft: 12,
										marginRight: 12,
										gap: 5,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/apkv9lfa_expires_30_days.png"} 
										style={{
											width: 24,
											height: 24,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 4,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Next Lesson"}
										</span>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 10,
												fontWeight: "bold",
											}} >
											{"Defining Your Unique Value Proposition"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 12,
										marginRight: 12,
										gap: 10,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 9,
											paddingLeft: 38,
											paddingRight: 38,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Continue"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											background: "linear-gradient(180deg, #74AED8, #1074BC)",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 9,
											paddingLeft: 28,
											paddingRight: 28,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"View Details"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 12,
									border: `1px solid #E6E6E6`,
									paddingTop: 19,
									paddingBottom: 19,
									marginBottom: 24,
									boxShadow: "0px 1px 2px #00000008",
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										marginBottom: 17,
										marginLeft: 9,
										marginRight: 9,
										gap: 7,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/qy7b4b9i_expires_30_days.png"} 
										style={{
											width: 54,
											height: 54,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
										}}>
										<span 
											style={{
												color: "#010101",
												fontSize: 12,
												fontWeight: "bold",
												marginBottom: 6,
											}} >
											{"Financial Planning for Entrepreneurs"}
										</span>
										<div 
											style={{
												display: "flex",
												alignItems: "center",
												marginBottom: 5,
												gap: 8,
											}}>
											<span 
												style={{
													color: "#F36421",
													fontSize: 12,
													fontWeight: "bold",
												}} >
												{"Completed 2/5 lessons"}
											</span>
											<div 
												style={{
													flexShrink: 0,
													display: "flex",
													flexDirection: "column",
													alignItems: "flex-start",
													background: "#EEBD10",
													borderRadius: 2,
													paddingTop: 3,
													paddingBottom: 3,
													paddingLeft: 6,
													paddingRight: 6,
												}}>
												<span 
													style={{
														color: "#FFFFFF",
														fontSize: 10,
														fontWeight: "bold",
													}} >
													{"In Progress"}
												</span>
											</div>
										</div>
										<div 
											style={{
												display: "flex",
												alignItems: "flex-start",
												gap: 13,
											}}>
											<span 
												style={{
													color: "#979797",
													fontSize: 10,
													fontWeight: "bold",
												}} >
												{"Last studied: 2 days ago"}
											</span>
											<span 
												style={{
													color: "#74AED8",
													fontSize: 10,
													fontWeight: "bold",
													marginTop: 2,
													marginBottom: 2,
												}} >
												{"50% Completed"}
											</span>
										</div>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										background: "#FEF0E9",
										borderRadius: 8,
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 13,
										paddingRight: 13,
										marginBottom: 12,
										marginLeft: 12,
										marginRight: 12,
										gap: 5,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ywu3vnti_expires_30_days.png"} 
										style={{
											width: 24,
											height: 24,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 4,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Next Lesson"}
										</span>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 10,
												fontWeight: "bold",
											}} >
											{"Understanding Revenue Models"}
										</span>
									</div>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "flex-start",
										marginLeft: 12,
										marginRight: 12,
										gap: 10,
									}}>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 9,
											paddingLeft: 38,
											paddingRight: 38,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Continue"}
										</span>
									</div>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											background: "linear-gradient(180deg, #74AED8, #1074BC)",
											borderRadius: 6,
											paddingTop: 8,
											paddingBottom: 9,
											paddingLeft: 28,
											paddingRight: 28,
										}}>
										<span 
											style={{
												color: "#FFFFFF",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"View Details"}
										</span>
									</div>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#E6F7FD",
									borderRadius: 8,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 117,
									paddingRight: 117,
									gap: 7,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										paddingBottom: 1,
									}}>
									<span 
										style={{
											color: "#00AEEF",
											fontSize: 14,
											fontWeight: "bold",
										}} >
										{"View All"}
									</span>
								</div>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/3b53yjrv_expires_30_days.png"} 
									style={{
										width: 1,
										height: 11,
										objectFit: "fill",
									}}
								/>
							</div>
						</div>
						<div 
							style={{
								width: 1,
								height: 1029,
								background: "#E6E6E6",
								marginRight: 23,
							}}>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								marginTop: 20,
							}}>
							<span 
								style={{
									color: "#979797",
									fontSize: 16,
									fontWeight: "bold",
									marginBottom: 15,
								}} >
								{"Module Details"}
							</span>
							<div 
								style={{
									width: 750,
									height: 1,
									background: "#E6E6E6",
									marginBottom: 24,
								}}>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 3,
									marginBottom: 28,
									gap: 2,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/xxw00cjo_expires_30_days.png"} 
									style={{
										width: 9,
										height: 22,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#010101",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"Module Overview"}
								</span>
							</div>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/w1vcn1l3_expires_30_days.png"} 
								style={{
									width: 750,
									height: 203,
									marginBottom: 25,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#010101",
									fontSize: 18,
									fontWeight: "bold",
									marginBottom: 12,
								}} >
								{"Entrepreneurship Fundamentals"}
							</span>
							<span 
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									marginBottom: 17,
								}} >
								{"Learn the foundational principles of starting and managing a business"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									gap: 26,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#FEF0E9",
										borderRadius: 8,
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 16,
										paddingRight: 16,
										marginTop: 2,
										marginBottom: 2,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/lurjoy9t_expires_30_days.png"} 
										style={{
											width: 24,
											height: 24,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 4,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Progress Summary"}
										</span>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Completed 3/5 Lessons"}
										</span>
									</div>
								</div>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "center",
										background: "#E6F7FD",
										borderRadius: 8,
										paddingTop: 10,
										paddingBottom: 10,
										paddingLeft: 16,
										paddingRight: 16,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/oc4yheu0_expires_30_days.png"} 
										style={{
											width: 24,
											height: 24,
											objectFit: "fill",
										}}
									/>
									<div 
										style={{
											flexShrink: 0,
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											gap: 4,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 10,
											}} >
											{"Estimated Completion Time"}
										</span>
										<span 
											style={{
												color: "#2C2C2C",
												fontSize: 12,
												fontWeight: "bold",
											}} >
											{"Approx. 6 hours remaining"}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}